/** Legacy session keys (kept for existing browser sessions). */
export const CONNECTED_TOOLKITS_SESSION_KEY = 'sia.briefing.connectedToolkits'
export const PREVIEW_ACCOUNT_ROWS_SESSION_KEY = 'sia.briefing.previewInboxAccountRows'
export const SETTINGS_DISMISSED_CONNECTION_IDS_KEY = 'sia.settings.dismissedConnectionIds'
